// extracted by mini-css-extract-plugin
export var avatar = "_r6-3";
export var avatarContainer = "_r6-2";
export var avatarSpacer = "_r6-5";
export var avatarSpacerContainer = "_r6-4";
export var avatarStackContainer = "_r6-1";
export var bubble = "_r6-0";
export var remainderBubble = "_r6-6";